import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Control, actions, Errors } from 'react-redux-form';
import { Button, Row, Col, FormGroup } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import { requestReset } from '../../../actions/login';
import TextViewer from '../../common/editor/text-viewer';

import './style.css';

import LockPopup from '../lock-popup';

class ForgottenPasswordForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showBothGivenError: false
    };
  }

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(actions.reset('deep.resetPW.step1'));
  }

  handleSubmit = (payLoad) => {
    const {email, mobile} = payLoad;
    if (email && mobile) {
      this.setState({
        showBothGivenError: true
      });
      return;
    }

    const { dispatch } = this.props;
    dispatch(actions.submitFields('deep.resetPW.step1', requestReset(payLoad)
      .catch((error) => {
        dispatch({type: 'PW_RESET_VALUE_REJECTED', payLoad: error.response.data.errors});

        const {errors} = error.response.data.errors;
        let rejectErrors = [];
        if (Object.prototype.toString.call(errors.user) === '[object Array]') {
          errors.user.forEach((curr) => {
            if (curr === 'INVALID_CREDENTIALS') {
              rejectErrors.push({invalid_creds: true})
            }
            if (curr === 'ACCOUNT_LOCKED') {
              rejectErrors.push({locked: true});
              this.setState({show: true});

            }
          });
          return Promise.reject(rejectErrors);
        } else {
          return Promise.reject(error.response.data.errors.errors);
        }

      })
    ));
  };

  resetErrors = () => {
    this.props.dispatch(actions.setErrors('deep.resetPW.step1.mobile', {invalid: false}));
    this.props.dispatch(actions.setErrors('deep.resetPW.step1.email', {invalid: false}));
    this.setState({
      showBothGivenError: false
    });
  };

  render() {

    return (
      <div className="container forgot-password-info">
        <Row>
          <Col lg={12}>
            <PageTitle>Forgot password</PageTitle>
          </Col>
        </Row>

        <TextViewer pageSlug='request-pin'></TextViewer>

        <Row>
          <Col lg={6}>
            <Form model="deep.resetPW.step1"
                  onChange={(values) => this.resetErrors()}
                  onSubmit={(values) => this.handleSubmit(values)}>

              <FormGroup>
                <label htmlFor=".email">Email</label>
                <Control.text className="form-control"
                              model=".email"
                              validateOn="change"
                              type="text" />
                <Errors show={{
                          touched: true,
                          focus: false
                        }}
                        className="errors"
                        model=".email"/>
              </FormGroup>
              <FormGroup>
                <label htmlFor=".mobile">Mobile</label>
                <Control.text className="form-control"
                              model=".mobile"
                              type="text" />
                <Errors show={{
                          touched: true,
                          focus: false
                        }}
                        className="errors"
                        model=".mobile"/>
              </FormGroup>

              <FormGroup>
                {this.state.showBothGivenError &&
                <div className="errors">Please enter either an email address OR mobile number</div>}

                <Button disabled={!this.props.formValid || this.state.showBothGivenError}
                        type="submit"
                        className="red-btn pull-right submit">
                  Reset Password
                </Button>
              </FormGroup>

            </Form>
            { this.state.show && <LockPopup route="/login"/> }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.resetPW.step1.$form.valid
  };
};

export default connect(mapStateToProps)(ForgottenPasswordForm);



// WEBPACK FOOTER //
// ./src/components/auth/forgotten-password-1/index.jsx